module.exports = __webpack_public_path__ + "img/InicioDebidaDiligencia.1d23fc5c.png";